import { Text } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';
import { CustomsCodeListItem } from '@texas/api/endpoints/metadata/customsCodesApi';
import { TFunction } from 'i18next';

const columnHelper = createColumnHelper<CustomsCodeListItem>();

export function customsCodeTableColumns(t: TFunction) {
  return [
    columnHelper.accessor('identifier', {
      header: t('general.code'),
      cell: (info) => (
        <Text variant="configuration-code">{info.getValue()}</Text>
      ),
    }),
    columnHelper.accessor('name', { header: t('general.name') }),
    columnHelper.accessor('branchName', { header: t('general.branch') }),
    columnHelper.accessor('archived', {
      header: t('general.status'),
      cell: (info) =>
        t(info.getValue() ? 'general.archived' : 'general.active'),
    }),
  ];
}
